'use client'

import React from 'react'
import { useAnimateOnVisible } from '@hooks/useAnimateOnVisible'
import { AboutAckoMock } from '@components/MediaKit/MediaKitMock'
import DownloadButton from '@components/MediaKit/DownloadButton/DownloadButton'
import styles from './AboutAcko.module.scss'

const AboutAcko = () => {
  const { ref, animationClassName } = useAnimateOnVisible<HTMLDivElement>({
    animationDelayMs: 180,
  })
  return (
    <div ref={ref} className={`${styles.aboutAckoContainer} ${animationClassName}`}>
      <div className={styles.aboutAckoHeadingContainer}>
        <p className={styles.aboutAckoTitle}>{AboutAckoMock.title}</p>
        <p className={styles.aboutAckoSubHeading}>{AboutAckoMock.subheading}</p>
      </div>
      <p className={styles.aboutAckoDescription}>{AboutAckoMock.description}</p>
      <DownloadButton url={AboutAckoMock.url} ctaText={AboutAckoMock.ctaText} journey={AboutAckoMock.journey} newPage />
    </div>
  )
}

export default AboutAcko
